export const reorder = <T>(list: T[], startIndex: number, endIndex: number) => {
  const orderedList = [...list];
  const [removed] = orderedList.splice(startIndex, 1);
  orderedList.splice(endIndex, 0, removed);

  return orderedList;
};
